import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import { isMobileDevice } from '@src/quince-site-common/src/helpers/getDeviceTypeForPageRouter'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'
import { FEATURE_FLAG_TYPE } from '@src/server-side/server-feature-flags/feature-flag.types'

import { Home } from './[...slug]/components/homepage'
import { HomepageFeatureProvider } from './[...slug]/components/homepage/homepage-feature-provider'
import Layout from './layout'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.HOME)
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageHome(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const homeFeatureFlags =
    props.serverSideFeatureFlags?.featureFlagType === FEATURE_FLAG_TYPE.HOME ? props.serverSideFeatureFlags : null

  return (
    <Layout {...props}>
      {props.pageData ? (
        <HomepageFeatureProvider serverSideFeatureFlags={homeFeatureFlags}>
          <Home pageContext={props.pageData.context?.pageDataJson} isMobile={isMobileDevice(props.deviceType)} />
        </HomepageFeatureProvider>
      ) : (
        <SomethingWentWrong />
      )}
    </Layout>
  )
}
